<template>
    <div>
        
            <fieldset :disabled="loading">
                <form v-if="step == 0" @submit.prevent="checkCaptchaRequirement">
                    <div v-show="!isAccountCodeHidden" class="form-group">
                        <label>{{translate('login.accountCode')}}</label>
                        <input v-model="loginData.accountCode" type="text" class="form-control" aria-describedby="accountHelp" required />
                    </div>
                    <div class="form-group">
                        <label>{{getLoginEMailFieldText}}</label>
                        <input v-model="loginData.email" type="text" class="form-control" aria-describedby="emailHelp" required />
                    </div>
                    <button type="submit" class="btn btn-success btn-block">{{translate('login.continue')}}</button>
                </form>
                <form v-else @submit.prevent="login">
                    <div class="form-group">
                        <label for="">{{translate('login.user')}}</label>
                        <div class="form-control text-center" style="height:auto; cursor:pointer;" @click="step=0" title="Değiştir">
                            <code>{{loginData.accountCode}}</code>
                            <div>{{loginData.email}}</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="d-flex justify-content-between">
                            <label>{{translate('login.password')}}</label>
                            <modifier-key-state-warning/>
                        </div>
                        <input v-model="loginData.password" type="password" class="form-control" aria-describedby="emailHelp" required oncopy="return false;" autocomplete="off" autofill="return false;"/>
                    </div>
                    <div class="form-group" v-show="captcha && captcha.isCaptchaRequired">
                        <label>{{translate('login.validationCode')}}</label>
                        <div class="input-group input-group-lg">
                            <div class="input-group-prepend">
                                <span class="input-group-text captcha" :title="translate('login.validationCodeTitle')" ref="captcha" @click="checkCaptchaRequirement()"></span>
                            </div>
                            <input v-model="loginData.Captcha" type="text" :placeholder="translate('login.validationCodeText')" class="form-control" :required="captcha && captcha.isCaptchaRequired " />
                        </div>
                    </div>
                    <button type="submit" class="btn btn-success btn-block">{{translate('login.login')}}</button>
                    <div v-if="errorMessage" class="text-danger">{{translate('login.error')}} {{errorMessage}}</div>
                </form>
            </fieldset>
            <div v-show="!isPasswordResetLinkHidden" class="text-center" style="padding:16px;">
                <router-link to="/ForgotPassword">{{translate('login.forgotPassword')}}</router-link>
            </div>
    </div>
</template>

<script>
import axios from 'axios'
import ModifierKeyStateWarning from '@/components/ModifierKeyStateWarning.vue'

export default {
  name: 'LoginWithEmail',
  components:{
      ModifierKeyStateWarning,
  },
  props: {
    
  },
  created(){    
      if(this.loginData.accountCode && this.loginData.email) {
          this.checkCaptchaRequirement();
      }
  },
  data: () => ({
    loading: false,
    loginData: {
        accountCode : window.settings.defaultAccountCode ?? window.localStorage.getItem('accountCode'),
        email: window.localStorage.getItem('email')
    },
    step: 0,
    captcha: null,
    errorMessage : null,
    timer: null,
  }),
  computed:{
    isAccountCodeHidden(){
        if(this.isOnPrem && window.settings.defaultAccountCode)
            return window.settings.authentication?.hideAccountCode;
        else
            return false;
     },
     isPasswordResetLinkHidden(){
        if(this.isOnPrem)
            return window.settings.authentication?.hidePasswordResetLink;
        else
            return false;
     },
     getLoginEMailFieldText(){
         if(this.isOnPrem)
            return window.settings.authentication?.emailText ?? this.translate('login.email');
         else
            return this.translate('login.email')
     } 
  },
  watch: {
    'loginData.password'(newValue) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (newValue === this.loginData.password) {
          this.loginData.password = '';
        }
      }, 20000);
    },
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    checkCaptchaRequirement()
    {
        this.step = 1;
        this.loading = true;
        axios.post('/token/isCaptchaRequired', { Email: this.loginData.email})
        .then(x => {
            this.captcha = x.data;
            this.loginData.Identifier = x.data?.identifier;
            this.$refs.captcha.style["background-image"] = `url('data:image/jpg;base64,${x.data.image}')`;
            this.loginData.Captcha = null;
            this.loading = false;
        })
        .catch(x => {
            this.step = 0;
            window.processErrorResponse(x, this);
            this.$refs.captcha.style["background-color"] = "red";
            this.$refs.captcha.style["background-image"] = "none";
            this.loginData.Identifier = null;
            this.loginData.Captcha = null;
            this.loading = false;
        })
    },
    async loginWithEmail(){
        const {data} = await axios.post("/token/post", {
                accountCode : this.loginData.accountCode,
                email: this.loginData.email,
                password: this.loginData.password,
                identifier: this.loginData.Identifier,
                captcha : this.loginData.Captcha
            });
        return data;
    },
    login(){
        console.log('Oluşturuldu:', this);
        this.loading = true;
        this.loginWithEmail()
        .then(x => {
            this.errorMessage = null;
            console.log("Gelen sonuç:", x);
            if(x.Success) {
                if(x.Data.SessionId)
                {
                    this.$router.push({ name:'/mfa', params: { loginData: x.Data }, query: { redirect: this.$route.query.redirect } });
                }
                else
                {
                    window.localStorage.setItem('user', JSON.stringify(x.Data));
					axios.defaults.headers.common['token'] = x.Data.Key;
					this.$root.$data.login = x.Data;

					window.localStorage.setItem('accountCode', x.Data.Account.Code);
					window.localStorage.setItem('email', x.Data.User.Email);

                    if(this.$route.query.redirect)
                        this.$router.push(this.$route.query.redirect);
                    else
                        this.$router.push('/' + x.Data.Account.Code);
                }
            } else {
                this.errorMessage = x.ErrorMessages;
                this.loginData.password = '';
                this.checkCaptchaRequirement();
            }
            console.log('Token geldi: ', axios.defaults.headers.common['token']);
        }).catch(e => {
            console.log('Error:', e);
            this.loginData.password = '';
            if(e.response === undefined) {
                this.errorMessage = this.translate('errors.cantConnectError');
            } else if(e.response.status == 400){
                this.errorMessage = window.getModelStateString(e.response.data.ModelState) || e.response.data.Message;
            } else {
                this.errorMessage = this.translate('errors.unexpectedError');
            }
            this.checkCaptchaRequirement();
        })
    }
  }
}
</script>
<style scoped>
.captcha {
    width:100px;
    background-repeat: no-repeat;
    background-position: center center;
    cursor: pointer;
}
</style>